/**
 * Polls a condition function until it returns true or a timeout is reached.
 * @public
 * @param conditionFunc - The condition function to poll.
 * @param timeoutMs - The timeout in milliseconds. Defaults to 300.
 * @returns A promise that resolves when the condition function returns true or rejects when the timeout is reached.
 */
export function until(conditionFunc, timeoutMs = 300) {
    const poll = (resolve) => {
        if (conditionFunc()) {
            resolve();
            return;
        }
        setTimeout(() => poll(resolve), timeoutMs);
    };
    return new Promise(poll);
}
